import React from 'react';
import PropTypes from 'prop-types';

import getUserColors from '../../../../common/getUserColors';
import * as Styled from './styles';

const UserAvatar = ({ user, useEmail, useLogo }) => {
    const { avatarBackgroundColor, avatarBorderColor } = getUserColors(user);
    const firstInitial = user.firstName[0];
    const secondInitial = user.lastName ? user.lastName[0] : '';
    const initials = useEmail
        ? `${user.email.slice(0, user.email.indexOf('@')).split(/[.\-_]+/, 2).map((name) => name.charAt(0)).join('')}`
        : `${firstInitial}${secondInitial}`;

    return (
        <Styled.AvatarBackground>
            <Styled.AvatarWrapper useLogo={useLogo} borderColor={avatarBorderColor} backgroundColor={avatarBackgroundColor}>
                {useLogo ?
                    <Styled.BananatagLogo src="https://app.bananatag.com/assets/images/Global/logo.svg" />
                    :
                    <Styled.Initials>{initials}</Styled.Initials>
                }
            </Styled.AvatarWrapper>
        </Styled.AvatarBackground>
    );
};

UserAvatar.propTypes = {
    user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
    }).isRequired,
    useEmail: PropTypes.bool.isRequired,
    useLogo: PropTypes.bool.isRequired,
};

export default UserAvatar;
